
import React from 'react';

export default function SolutionSection() {
  const features = [
    {
      title: 'Get Quality Leads',
      description:
        'Get pre-qualified leads from homeowners actively seeking services in your area.',
      image:
        'https://static.readdy.ai/image/15154fd60635729eaa8281dee4e4e9cb/d0dafbfaf2de4e103ca9ad21d5e93f8d.jpeg',
    },
    {
      title: 'Connect on the Go',
      description:
        'Manage leads and respond to clients instantly from anywhere.',
      image:
        'https://static.readdy.ai/image/15154fd60635729eaa8281dee4e4e9cb/ec7d3a6b23f1ccff6362f5d44540e5a8.jpeg',
    },
    {
      title: 'Build Trust',
      description: 'Manage your reviews from your profile.',
      image:
        'https://static.readdy.ai/image/15154fd60635729eaa8281dee4e4e9cb/16b721074f068a3153150e0f6010844e.jpeg',
    },
    {
      title: 'Grow Yourself',
      description:
        'See who is viewing your projects and interests shown in leads in real time.',
      image:
        'https://static.readdy.ai/image/15154fd60635729eaa8281dee4e4e9cb/217b5365718cb71f8f82ba41919d10e7.jpeg',
    },
  ];

  return (
    <section
      id="essential-tools"
      className="py-12 sm:py-16 lg:py-24 bg-white relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-block px-3 sm:px-4 py-2 bg-[#35C5F0] bg-opacity-10 border border-[#35C5F0] border-opacity-30 rounded-full text-[#35C5F0] text-xs sm:text-sm font-semibold mb-4 sm:mb-6">
            What&apos;s Next ?
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-[#2F3438] mb-4 sm:mb-6">
            Coming Soon
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-[#ABB2B9] max-w-3xl mx-auto px-4">
            Everything you need to showcase your work, manage clients, and grow
            your business.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border border-[#ABB2B9] border-opacity-20 p-4 sm:p-6 hover:shadow-xl hover:border-[#35C5F0] hover:border-opacity-30 transition-all group"
            >
              <div className="mb-4 rounded-xl overflow-hidden bg-[#F8F9FA] h-52 sm:h-60 lg:h-64">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>

              <h3 className="text-lg sm:text-xl font-bold text-[#2F3438] mb-2 sm:mb-3">
                {feature.title}
              </h3>
              <p className="text-sm sm:text-base text-[#ABB2B9] leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 sm:mt-16 text-center">
          <div className="inline-flex items-center gap-2 text-[#ABB2B9] text-sm sm:text-base">
            <i className="ri-check-line text-[#35C5F0]"></i>
            <span>All features included in the free plan</span>
          </div>
        </div>
      </div>
    </section>
  );
}
